import './index.css'
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const mainCategory = document.getElementById('mainCategory')?.getAttribute('mainCategory') || 12
const eventDate = document.getElementById('eventDate')?.getAttribute('eventDate') || ''
const eventMenuLink = document.getElementById('eventMenuLink')?.getAttribute('eventMenuLink') || 'events'
root.render(
    <App mainCategory={mainCategory} eventDate={eventDate} eventMenuLink={eventMenuLink}/>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
